module.exports = __webpack_public_path__ + "img/passport_one.76bf1bf8.png";